import React, { forwardRef } from "react";
import "./Contact.css";
import { Fade } from "react-awesome-reveal";


const Contact = forwardRef((props, ref) => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="contact-slide" id="contact" ref={ref}>
            <footer className="footer">
                <h3>Sensoryomics</h3>
                <div className="footer-content">


                    <div className="footer-section ">
                        <div><h4>Our Address</h4></div>
                        <div className="address">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                            </svg>
                                <a href="https://maps.app.goo.gl/5oMMMhfyRTCfAz7x6" target="_blank" rel="noopener noreferrer">
                                    800 W. Campbell Rd<br />
                                    BSB 14.102<br />
                                    Richardson, TX 75080<br />
                                    The University of Texas at Dallas
                                </a>
                        </div>
                    </div>
                    <div className="footer-section">
                        <div><h4>Contact Us</h4></div>
                        <div className="contact-column">
                            <div className="contact-row">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                                </svg><p><a href="mailto:caps@utdallas.edu">caps@utdallas.edu</a></p>
                            </div>
                            <div className="contact-row">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                </svg><p><a href="tel:972-883-6897">(972)-883-6897</a></p>
                            </div>
                        </div>

                    </div>
                    <div className="footer-section">
                        <div><h4>Get Social</h4></div>
                        <div className="social-icons">
                            <a href="https://www.instagram.com/utdpaincenter/" target="_blank" rel="noopener noreferrer">
                                <i id="instagram-icon" className="fab fa-instagram"></i>
                            </a>
                            <a href="https://www.youtube.com/channel/UC172TED0zMWvx9mszhvvtgQ" target="_blank" rel="noopener noreferrer">
                                <i id="youtube-icon" className="fab fa-youtube"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/center-for-advanced-pain-studies/" target="_blank" rel="noopener noreferrer">
                                <i id="linkedin-icon" className="fab fa-linkedin-in"></i>
                            </a>
                        </div>
                        {/* <p style={{ border: "1px solid #ddd", borderRadius: "20px", padding: "0px" }}><pre>    Tag us in your photos!    </pre></p> */}
                    </div>
                </div>
                <div id="logo">
                    <img src="social-in-white-circle.png" className="caps-logo"></img>
                </div>
            </footer>
            <div className="footer-bottom">
                <p>&copy; 2026 Center for Advanced Pain Studies.</p>
                <div className="back-to-top" onClick={scrollToTop}><svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" fill="#ddd" class="bi bi-arrow-up-circle" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z" />
                </svg></div>
            </div>
        </div>
    );
});

export default Contact;